import { navbarIcons } from "helpers/images";
import React from "react";
import classess from "./styles.module.scss";

export const AuthLayout = ({ children }) => {
  return (
    <div className="container-fluid">
      <div className={`${classess.authLayout} row`}>
        <div
          className={`${classess.authBackground} col-lg-6 col-12 d-flex justify-content-center align-items-center`}
        >
          <img src={navbarIcons.logo} className="img-fluid" alt="logo" />
        </div>
        <div className={`${classess.authContentBackground} col-lg-6 col-12`}>
          {children}
        </div>
      </div>
    </div>
  );
};
